import config from 'config';
import { PaginatedResponse, PostOverview, ProfileSocialOverview } from 'types';
import { api } from './api';

const SOCIAL_API = config.socialApi;

export const socialApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPostOverviewAsLoggedInUser: build.query<PostOverview, string>({
      query: (creatorsContentId) => ({
        url: `${SOCIAL_API}/feeds/${creatorsContentId}/overview`,
        headers: { 'x-api-version': '2.0' },
        withAccessToken: true,
      }),
    }),
    getProfileSocialInfo: build.query<ProfileSocialOverview, string>({
      query: (influencerId) => ({
        url: `${SOCIAL_API}/influencers/${influencerId}/social-overview`,
        withAccessToken: true,
      }),
    }),
    getPostOverview: build.query<PostOverview, string>({
      query: (creatorsContentId) => ({
        url: `${SOCIAL_API}/v1/sharing/${creatorsContentId}/overview`,
      }),
    }),

    getSuggestedCreators: build.query<
      PaginatedResponse<{ id: string; name: string; username: string }>,
      { limit: number; offset: number }
    >({
      query: ({ limit, offset }) => ({
        url: `${SOCIAL_API}/v1/citizens/me/suggested-creators?offset=${offset}&size=${limit}`,
        withAccessToken: true,
      }),
      transformResponse: (response: any, _, { offset, limit }) => {
        const updatedResponse = {
          ...response,
          page: offset / limit + 1,
          data: response.data.map((item: { id: string; name: string; username: string }) => ({
            ...item,
            isVerifiedCreator: true,
          })),
        };
        return updatedResponse;
      },
    }),
  }),
});

export const { useGetPostOverviewAsLoggedInUserQuery, useGetSuggestedCreatorsQuery } = socialApi;
